import { useEffect, useCallback, useRef } from "react";
import { types } from "@vilocnv/allsetra-core";
import { useAppDispatch, useAppSelector } from "./index";
import {
  getObjectDataForMapThunk,
  updateObjectLocation,
  updateObjectIcon
} from "app/features";
import { SignalRService } from "app/data/services";
import { selectDrawerSelectedAccountId } from "app/data/selectors";

const useObjectLiveLocation = (isSelectOpen = false) => {
  const dispatch = useAppDispatch();
  const drawerSelectedAccountId = useAppSelector(selectDrawerSelectedAccountId);
  const isSelectOpenRef = useRef(isSelectOpen);

  useEffect(() => {
    isSelectOpenRef.current = isSelectOpen;
  }, [isSelectOpen]);

  const updateLiveObject = useCallback(
    (event: any) => {
      // If the select search of objects is open
      // Then we don't process the event
      if (isSelectOpenRef.current) return;

      if (
        event.eventName === types.BackendEventsEnum.ObjectLocationReportedEvent
      ) {
        dispatch(updateObjectLocation(event));
      } else if (
        event.eventName === types.BackendEventsEnum.ObjectIconUpdatedEvent
      ) {
        dispatch(updateObjectIcon(event));
        const objectId = window.localStorage.getItem("selectedObjectId");

        if (
          drawerSelectedAccountId &&
          objectId &&
          event.uniqueId === objectId
        ) {
          dispatch(
            getObjectDataForMapThunk({
              accountId: drawerSelectedAccountId || "",
              objectId: objectId
            })
          );
        }
      }
    },
    [dispatch, drawerSelectedAccountId]
  );

  useEffect(() => {
    SignalRService.hubConnection?.on("EventRaised", updateLiveObject);

    return () => {
      SignalRService.hubConnection?.off("EventRaised");
    };
  }, [updateLiveObject]);
};

export default useObjectLiveLocation;
